module.exports = renderConfirmationView;


function renderConfirmationView() {
  console.log('firing renderConfirmationView');
  $('#content').addClass('confirmation-view')
  $('#top').remove();
  $('#main').remove();

  const message = 'Your request has been submitted.\n' +
    'You will receive an email when the appointment is confirmed.';

  const $message = $(document.createElement('div'))
    .attr('id', 'confirmation-message')
    .addClass('font-lg');

  $($message).html(message);
  $('#bottom').before($message);
}



// WEBPACK FOOTER //
// ./public/src/confirmationView.js